// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes page-transition-slide-in {
  from {
    transform: translateX(7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-reverse-slide-in {
  from {
    transform: translateX(-7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-slide-out {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-7.5rem);
  }
}
@keyframes width-grow {
  from {
    transform: scaleX(0.001);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes width-shrink {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0.001);
  }
}
@keyframes height-grow {
  from {
    transform: scaleY(0.0001);
  }
  to {
    transform: scaleY(1);
  }
}
@keyframes height-fade-and-grow {
  from {
    opacity: 0;
    transform: scaleY(0.0001);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes height-shrink {
  from {
    transform: scaleY(1);
  }
  to {
    transform: scaleY(0.001);
  }
}
@keyframes roll-in {
  from {
    opacity: 0;
    transform: translateX(10rem) rotate(500deg);
  }
  to {
    opacity: 1;
    transform: translateX(0) rotate(0);
  }
}
@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateX(5rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slide-out {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-5rem);
  }
}
@keyframes drop {
  0% {
    transform: translateY(-1rem);
  }
  100% {
    transform: translateY(0);
  }
}
app-root section.carousel .carousel-item {
  will-change: transform, opacity;
  animation: slide-in 0.3s ease-in-out backwards;
}
app-root section.carousel .carousel-item.hide {
  animation: slide-out 0.3s ease-in-out forwards;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/animations.less","webpack://./src/Components/UI/Carousel/CarouselItem.less"],"names":[],"mappings":"AACE;EACE;IACE,UAAA;ECAJ;EDGE;IACE,UAAA;ECDJ;AACF;ADIE;EACE;IACE,UAAA;ECFJ;EDKE;IACE,UAAA;ECHJ;AACF;ADME;EACE;IACE,6BAAA;ECJJ;EDOE;IACE,wBAAA;ECLJ;AACF;ADQE;EACE;IACE,8BAAA;ECNJ;EDSE;IACE,wBAAA;ECPJ;AACF;ADUE;EACE;IACE,wBAAA;ECRJ;EDWE;IACE,8BAAA;ECTJ;AACF;ADYE;EACE;IACE,wBAAA;ECVJ;EDaE;IACE,oBAAA;ECXJ;AACF;ADcE;EACE;IACE,oBAAA;ECZJ;EDeE;IACE,wBAAA;ECbJ;AACF;ADgBE;EACE;IACE,yBAAA;ECdJ;EDiBE;IACE,oBAAA;ECfJ;AACF;ADkBE;EACE;IACE,UAAA;IACA,yBAAA;EChBJ;EDmBE;IACE,UAAA;IACA,oBAAA;ECjBJ;AACF;ADoBE;EACE;IACE,oBAAA;EClBJ;EDqBE;IACE,wBAAA;ECnBJ;AACF;ADsBE;EACE;IACE,UAAA;IACA,2CAAA;ECpBJ;EDsBE;IACE,UAAA;IACA,kCAAA;ECpBJ;AACF;ADuBE;EACE;IACE,UAAA;IACA,2BAAA;ECrBJ;EDuBE;IACE,UAAA;IACA,wBAAA;ECrBJ;AACF;ADwBE;EACE;IACE,UAAA;IACA,2BAAA;ECtBJ;EDwBE;IACE,UAAA;IACA,wBAAA;ECtBJ;AACF;ADyBE;EACE;IACE,UAAA;IACA,wBAAA;ECvBJ;EDyBE;IACE,UAAA;IACA,4BAAA;ECvBJ;AACF;AD0BE;EACE;IACE,4BAAA;ECxBJ;ED2BE;IACE,wBAAA;ECzBJ;AACF;AA/HA;EAGM,+BAAA;EACA,8CAAA;AA+HN;AA9HM;EACE,8CAAA;AAgIR","sourcesContent":["app-root {\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fade-out {\n    from {\n      opacity: 1;\n    }\n\n    to {\n      opacity: 0;\n    }\n  }\n\n  @keyframes page-transition-slide-in {\n    from {\n      transform: translateX(7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-reverse-slide-in {\n    from {\n      transform: translateX(-7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-slide-out {\n    from {\n      transform: translateX(0);\n    }\n\n    to {\n      transform: translateX(-7.5rem);\n    }\n  }\n\n  @keyframes width-grow {\n    from {\n      transform: scaleX(0.001);\n    }\n\n    to {\n      transform: scaleX(1);\n    }\n  }\n\n  @keyframes width-shrink {\n    from {\n      transform: scaleX(1);\n    }\n\n    to {\n      transform: scaleX(0.001);\n    }\n  }\n\n  @keyframes height-grow {\n    from {\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-fade-and-grow {\n    from {\n      opacity: 0;\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      opacity: 1;\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-shrink {\n    from {\n      transform: scaleY(1);\n    }\n\n    to {\n      transform: scaleY(0.001);\n    }\n  }\n\n  @keyframes roll-in {\n    from {\n      opacity: 0;\n      transform: translateX(10rem) rotate(500deg);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0) rotate(0);\n    }\n  }\n\n  @keyframes slide-up {\n    from {\n      opacity: 0;\n      transform: translateY(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slide-in {\n    from {\n      opacity: 0;\n      transform: translateX(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes slide-out {\n    from {\n      opacity: 1;\n      transform: translateX(0);\n    }\n    to {\n      opacity: 0;\n      transform: translateX(-5rem);\n    }\n  }\n\n  @keyframes drop {\n    0% {\n      transform: translateY(-1rem);\n    }\n\n    100% {\n      transform: translateY(0);\n    }\n  }\n}\n\n.cubic-slide-in-animation(@delay: 0s) {\n  animation: 0.25s ease-in normal backwards @delay fade-in,\n    0.3s cubic-bezier(0.39, 0.67, 0.61, 0.96) normal backwards @delay page-transition-slide-in;\n}\n.cubic-reverse-slide-in-animation(@delay: 0s) {\n  animation: 0.4s ease-in normal backwards @delay fade-in,\n    0.2s cubic-bezier(0.23, 0.06, 0.55, 0.42) normal backwards @delay\n      page-transition-reverse-slide-in;\n}\n.cubic-slide-out-animation(@delay: 0s) {\n  animation: 0.3s ease-in @delay forwards fade-out,\n    0.3s cubic-bezier(0.23, 0.06, 0.55, 0.42) @delay forwards page-transition-slide-out;\n}\n","@import '../../../Styles/animations.less';\n\napp-root {\n  section.carousel {\n    .carousel-item {\n      will-change: transform, opacity;\n      animation: slide-in 0.3s ease-in-out backwards;\n      &.hide {\n        animation: slide-out 0.3s ease-in-out forwards;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
